// extracted by mini-css-extract-plugin
export default {"Main":"FanAppPage-module__Main__PjeP9","FixedHeader":"FanAppPage-module__FixedHeader__hBg0_"};